import Vue from 'vue'
import Router from 'vue-router'

// Default Container
import DefaultContainer from '@/container/Full'
import PublicContainer from '@/container/PublicFull'

// Dashboard
import { routerDashboard } from './dashboard'

// Widget
import routerWidget from './widget/widget'
import routerRevenueTourism from './widget/revenue_tourism'
import routerPublicRelation from './widget/public_relation'
import routerVoiceOfCustomer from './widget/voice_of_customer'
import routerVoiceOfStakeholder from './widget/voice_of_stakeholder'
import routerMarketingActivity from './widget/marketing_activity'
import routerCompetitors from './widget/competitors'
import routerInformation from './widget/information'
import routerContactInformation from './widget/contact_information'
import routerMarket from './widget/market'
import routerSupply from './widget/supply'
import routerEform from './widget/eform'
import routerSearch from './widget/search'
import routerPublic from './widget/public'
import routerImmigrations from './widget/immigrations'
import routerCdds from './widget/cdds'
import routerCaats from './widget/caats'
import routerAccess from './widget/access'
import routeMonitorTravel from './monitor_travel'

// Document
import routerDocument from './document'

// Setting
import routerSetting from './setting'

// User
import routerUser from './user'

// Dev
// import {routerDev} from './dev'
// User Permission
import routerUserPermission from './user_permission'

Vue.use(Router)

// redirect: process.env.HIDE_TEMPORARY_MENU =='true' ? "/admin/dashboard/immigration-checkpoint" : "/admin/dashboard/travel-overview",  // /admin/dashboard/travel-overview

export default new Router({
    mode: 'history',
    base: process.env.NODE_ENV == 'production' ? '' : '',
    routes: [
        {
            path: '/',
            name: 'Dashboard',
            redirect: '/admin/dashboard',
        },
        {
            path: '/admin',
            name: 'Dashboard',
            redirect: '/admin/dashboard',
        },
        {
            path: '/admin/dashboard',
            redirect: '',
            name: 'Home',
            component: DefaultContainer,
            children: [
                ...routerDashboard,
                ...routerWidget,
                ...routerRevenueTourism,
                ...routerPublicRelation,
                ...routerVoiceOfCustomer,
                ...routerVoiceOfStakeholder,
                ...routerMarketingActivity,
                ...routerCompetitors,
                ...routerInformation,
                ...routerContactInformation,
                ...routerMarket,
                ...routerSupply,
                ...routerDocument,
                ...routerEform,
                ...routerUserPermission,
                ...routerSearch,
                ...routerImmigrations,
                ...routerCdds,
                ...routerCaats,
                ...routerAccess,
            ],
        },
        {
          path: '/admin/dashboard/monitor-travel',
          name: 'MonitorTravel',
          component: DefaultContainer,
          children: [
            ...routeMonitorTravel,
          ]
        },
        {
            path: '/admin/setting',
            name: 'Setting',
            redirect: '/admin/setting/category',
            component: DefaultContainer,
            children: [...routerSetting],
        },
        ...routerUser,
        {
            path: '/public',
            name: 'Public',
            redirect: '/public/widget/voice-of-customer/29',
            component: PublicContainer,
            children: [...routerPublic],
        },
    ],
})
